import { Stack, Typography } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { Resources, useResource } from "Translations/Resources";
import SendIcon from "@mui/icons-material/Send";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  isSubmitting: boolean;
  hasReceiver: boolean;
  onPublish: () => void;
};

export const PublishAction = ({
  isSubmitting,
  hasReceiver,
  onPublish,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <PrimaryButton
        fullWidth
        isLoading={isSubmitting}
        variant="contained"
        color="success"
        onClick={onPublish}
        disabled={!hasReceiver}
        sx={{
          color: "white",
          "&:hover": { bgcolor: "success.dark" },
        }}
        endIcon={<SendIcon />}
      >
        {t(RESOURCES.PublishButton)}
      </PrimaryButton>
      {!hasReceiver && (
        <Typography variant="caption" color="error" textAlign="center">
          {t(RESOURCES.PublishRequiresReceiver)}
        </Typography>
      )}
    </Stack>
  );
};
